"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const SendTestComponent_1 = require("./SendTestComponent");
const SendTestConfirmationDialog_1 = require("./SendTestConfirmationDialog");
const PublishCampaignConfirmationDialog_1 = require("./PublishCampaignConfirmationDialog");
const DeleteTestDevicesConfirmationDialog_1 = require("./DeleteTestDevicesConfirmationDialog");
const getCampaignType_1 = require("../../utils/getCampaignType");
const user_1 = require("../../../reducers/user");
class OverviewModalFooter extends React.Component {
    constructor(props) {
        super(props);
        this.closeDeleteTestDevicesPrompt = () => {
            this.setState({
                showDeleteDevicesDialog: false,
            });
        };
        this.showDeleteTestDevicesPrompt = () => {
            this.handleSendTestToggle(false);
            this.setState({
                showDeleteDevicesDialog: true,
            });
        };
        this.state = {
            toggleSendTest: false,
            sendTestPrompt: false,
            showPublishCampaignDialog: false,
            showDeleteDevicesDialog: false,
        };
        this.handleSendTestToggle = this.handleSendTestToggle.bind(this);
        this.handleSendTestPrompt = this.handleSendTestPrompt.bind(this);
        this.handlePublishCampaignPrompt = this.handlePublishCampaignPrompt.bind(this);
    }
    handleSendTestToggle(on) {
        const { device } = this.props;
        const { notificationProgress } = this.props;
        if (notificationProgress === 100) {
            if (device !== 'Mobile') {
                this.setState({
                    toggleSendTest: !this.state.toggleSendTest,
                });
            }
            else {
                this.props.handleSendTestModalDisplay(on);
                if (on) {
                    this.setState({
                        toggleSendTest: !this.state.toggleSendTest,
                    });
                }
                else {
                    setTimeout(() => {
                        this.setState({
                            toggleSendTest: !this.state.toggleSendTest,
                        });
                    }, 300);
                }
            }
        }
    }
    handleSendTestPrompt() {
        this.setState({
            toggleSendTest: false,
            sendTestPrompt: !this.state.sendTestPrompt,
        });
    }
    handlePublishCampaignPrompt() {
        this.setState({
            showPublishCampaignDialog: !this.state.showPublishCampaignDialog,
        });
    }
    render() {
        const { user, scheduledDeliveryProgress, notificationProgress, device, testDevices, campaign, automatedDeliveryProgress, apiDeliveryProgress, } = this.props;
        const { trigger, id } = campaign;
        const { toggleSendTest, sendTestPrompt, showPublishCampaignDialog, showDeleteDevicesDialog } = this.state;
        const getPopoverTrigger = () => {
            const popoverProps = {
                placement: 'top',
            };
            const node = (React.createElement("div", { style: {
                    height: 312,
                    width: 384,
                }, key: "sendTest2" },
                React.createElement(SendTestComponent_1.default, { close: () => this.handleSendTestToggle(false), device: device, buttonLeftCallback: () => this.handleSendTestToggle(false), listOfTestDevices: testDevices, buttonRightCallback: this.handleSendTestPrompt, showDeleteTestDevicesConfirmation: this.showDeleteTestDevicesPrompt })));
            const sendTestButton = (React.createElement(src_1.Button, { text: "Send a Test", size: "large", type: notificationProgress === 100 ? 'secondary' : 'disabled', overrideWidth: 114, style: { outerStyle: { marginRight: 16 } }, key: "sendTest1", onClick: () => {
                    if (device !== 'Desktop') {
                        this.handleSendTestToggle(true);
                    }
                } }));
            if (device !== 'Mobile') {
                return (React.createElement(src_1.PopoverContainer, { id: "sendTest", popoverProps: popoverProps, targetParent: "root", onClick: this.handleSendTestToggle, showPopover: this.state.toggleSendTest }, [sendTestButton, node]));
            }
            else {
                const Fragment = React.Fragment;
                return (React.createElement(Fragment, null,
                    sendTestButton,
                    toggleSendTest &&
                        ReactDOM.createPortal(node, document.getElementById('overviewComponentRoot'))));
            }
        };
        const isButtonActive = () => {
            if (user.permissionScopes.includes('support')) {
                return false;
            }
            if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
                return notificationProgress === 100 && scheduledDeliveryProgress === 100;
            }
            if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
                return notificationProgress === 100 && automatedDeliveryProgress === 100;
            }
            if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
                return notificationProgress === 100 && apiDeliveryProgress === 100;
            }
            return false;
        };
        return (React.createElement("div", { style: {
                height: 80,
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                borderTop: `1px solid ${src_1.titanium}`,
                flex: 'none',
                background: src_1.white,
                position: 'absolute',
                bottom: 0,
            } },
            React.createElement("div", { style: {
                    margin: '16px 32px 16px',
                    display: 'flex',
                } },
                (getCampaignType_1.isScheduledCampaignTrigger(trigger) || getCampaignType_1.isAutomatedCampaignTrigger(trigger)) &&
                    getPopoverTrigger(),
                sendTestPrompt && (React.createElement(SendTestConfirmationDialog_1.default, { handleSendTestPrompt: this.handleSendTestPrompt, campaignId: parseInt(id, 10), device: device })),
                React.createElement(src_1.Button, { text: "Publish", size: "large", type: isButtonActive() ? 'primary' : 'disabled', overrideWidth: 114, onClick: this.handlePublishCampaignPrompt }),
                showPublishCampaignDialog && (React.createElement(PublishCampaignConfirmationDialog_1.default, { campaignId: parseInt(id, 10), device: device, handlePublishCampaignPrompt: this.handlePublishCampaignPrompt })),
                showDeleteDevicesDialog && (React.createElement(DeleteTestDevicesConfirmationDialog_1.default, { close: this.closeDeleteTestDevicesPrompt, device: device })))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        handleSendTestModalDisplay: (on) => {
            dispatch(actions_1.handleSendTestModalDisplay(on));
        },
    };
};
const mapStatetoProps = (state) => ({
    user: user_1.getUser(state.user),
    scheduledDeliveryProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'scheduleddelivery'),
    notificationProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'notification'),
    automatedDeliveryProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'automateddelivery'),
    apiDeliveryProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'delivery'),
    testDevices: reducers_1.getTestDevices(state),
});
exports.default = react_redux_1.connect(mapStatetoProps, mapDispatchToProps)(OverviewModalFooter);
